export default __webpack_public_path__ + "static/media/layamr-web4.88ccd61e.png";